#import "../fragments/sales-automation-stageset.graphql"

mutation UpdateClosedLeadTaskTemplate($taskTemplate: UpdateClosedLeadTaskTemplateInputFieldInput!) {
    updateClosedLeadTaskTemplate(input: {taskTemplate: $taskTemplate}) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
